import { Crm } from 'domain/crm';
import { useCrmStatusQuery } from 'features/crm/useCrmStatusQuery';

export const useCrmStatus = () => {
  const hsStatusQuery = useCrmStatusQuery(Crm.hubspot);
  const sfStatusQuery = useCrmStatusQuery(Crm.salesforce);

  const isHbIntegrated = !!hsStatusQuery.data;
  const isSfIntegrated = !!sfStatusQuery.data;
  const isHbExportEnabled = hsStatusQuery.data?.isContactExportEnabled;
  const isSfExportEnabled = sfStatusQuery.data?.isContactExportEnabled || sfStatusQuery.data?.isLeadExportEnabled;

  return {
    isHbIntegrated,
    isSfIntegrated,
    isHbExportEnabled,
    isSfExportEnabled,
    isSfLabelsEnabled: sfStatusQuery.data?.isCrmLabelsEnabled,
    isHbLabelsEnabled: hsStatusQuery.data?.isCrmLabelsEnabled,
    isLoading: hsStatusQuery.isLoading || sfStatusQuery.isLoading,
  };
};
